import SimulationInsights from "./reducers/SimulationInsights";
import ReportListingReducers from "./reducers/ReportListing";


export default {
    report:ReportListingReducers,
    simulationInsightReport:SimulationInsights
}